import { Capacitor } from "@capacitor/core"
import { Device, type DeviceInfo } from "@capacitor/device"

let deviceId: Promise<string> | undefined

export function getDeviceId(): Promise<string> {
	deviceId ??= Device.getId()
		.then(({ identifier }) => identifier)
		.catch((error: unknown) => {
			deviceId = undefined
			throw error
		})
	return deviceId
}

export type NativeDeviceInfo = Pick<
	DeviceInfo,
	"manufacturer" | "model" | "operatingSystem" | "osVersion"
>

/**
 * On native, the function gives the `Device.getInfo()` data. On other platforms
 * it gives `null`, because the web implementation does not parse the user agent
 * correctly. It also gives `null` when the plugin fails.
 */
export async function getNativeDeviceInfo(): Promise<NativeDeviceInfo | null> {
	if (!Capacitor.isNativePlatform()) return null
	try {
		return await Device.getInfo()
	} catch {
		return null
	}
}
